<!-- 销售订单确认收款页面 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section-title">
            <div>申请收款记录</div>
            <div>
                <el-button
                    size="small"
                    class="search-btn btn-primary"
                    @click="finishReceipt()"
                    v-if="permission.saleGatheringFunc && action == 'creceipt' && !submitData.IsPay && submitData.IsDelivery"
                    >完成收款</el-button
                >
                <el-button
                    size="small"
                    class="search-btn btn-primary"
                    @click="finishAndEditReceipt()"
                    v-else-if="permission.editAndConfirm && action == 'creceipt' && !submitData.IsPay && submitData.IsDelivery"
                    >完成收款</el-button
                >
                <i v-if="!submitData.IsDelivery" style="font-weight: normal; color: grey; font-size: 12px">※ 需要完成出仓才能完成收款操作</i>
                <el-link :underline="false" type="success" style="cursor: auto" v-if="submitData.IsPay">已完成收款</el-link>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="receiptRecords"
                show-summary
                :summary-method="getSummaries_apply"
                border=""
                style="width: 100%; margin-bottom: 10px; margin-top: 0px"
            >
                <el-table-column show-overflow-tooltip width="190px" prop="PayCode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="SumPayable" label="订单总金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="ApplyPay" label="申请收款金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="NowPay" label="实收金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="150px" prop="PayTypeName" label="结算方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="申请人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="申请时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80px">
                    <template slot-scope="scope">
                        <div class="ops-ctn" v-if="!scope.row.IsConfirm && !scope.row.IsCancel && permission.saleGatheringFunc && action == 'creceipt'">
                            <el-button
                                title="确认"
                                size="mini"
                                type="text"
                                v-if="submitData.IsDelivery && receiptRecordsUnConfirmCount == 1 && submitData.Paid + scope.row.NowPay >= submitData.SurplusMoney"
                                @click="showReceiptDialog(scope.row)"
                                >{{ permission.saleGatheringFunc }}</el-button
                            >
                            <el-button title="确认" size="mini" type="text" v-else @click="confirmPayRecord(scope.row)">{{ permission.saleGatheringFunc }}</el-button>
                        </div>
                        <div class="ops-ctn" v-else-if="!scope.row.IsConfirm && !scope.row.IsCancel && permission.editAndConfirm && action == 'creceipt'">
                            <el-button title="确认" size="mini" type="text" @click="showConfirmDialog(scope.row)">{{ permission.editAndConfirm }}</el-button>
                        </div>
                        <div class="ops-ctn" v-else-if="(action != 'creceipt' || permission.saleGatheringFunc) && !scope.row.IsConfirm && !scope.row.IsCancel">未确认</div>
                        <div class="ops-ctn" v-else-if="!scope.row.IsConfirm && scope.row.IsCancel">已撤销</div>
                        <div class="ops-ctn" v-else-if="scope.row.IsConfirm && !scope.row.IsCancel">已确认</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--   form     -->
        <div class="section-title" @click="showMsg">
            <div>
                <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span v-show="!showOrderMsg && submitData.EntpCusName">客户：{{ submitData.EntpCusName }}</span>
            </div>
        </div>
        <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
            <img src="../../../assets/images/open-msg.png" />
        </div>
        <div class="revenue-order-infoes" v-show="showOrderMsg">
            <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 15px; padding-left: 15px; padding-bottom: 10px">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客户" prop="EntpCusId">
                                <el-input size="small" style="width: 100%" disabled v-model="submitData.EntpCusName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="业务员" prop="SId">
                                <el-input size="small" style="width: 100%" disabled v-model="submitData.SName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="联系电话" prop="PhoneNum">
                                <el-input size="small" disabled v-model="submitData.PhoneNum"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipType">
                                <el-input size="small" disabled v-model="submitData.ShipTypeName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="运输费用" prop="ShipAmount">
                                <el-input size="small" disabled v-model="submitData.ShipAmount"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="结算方式" prop="PayType">
                                <el-input size="small" disabled v-model="submitData.PayTypeName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6" v-if="funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="跟单采购员" prop="SId">
                                <el-input size="small" disabled v-model="submitData.FollowerName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" v-if="!funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-input size="small" style="width: 100%" disabled v-model="submitData.FullAddress"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="9" v-if="funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-input size="small" style="width: 100%" disabled v-model="submitData.FullAddress"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="funcConfig ? 9 : 12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客人要求">
                                <el-input size="small" style="width: 100%" disabled v-model.trim="submitData.Remark"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="orderImages.length > 0">
                    <el-col :span="24">
                        <div class="form-uploadImg">
                            <div>流水单据：</div>
                            <el-upload
                                :action="uploadImgUrl"
                                :headers="headerObj"
                                :data="uploadImgData"
                                :file-list="orderImages"
                                :disabled="true"
                                list-type="picture-card"
                                accept="image/jpeg, image/png"
                                :on-preview="onUploadPreview"
                                class="hideUpload"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogImageVisible">
                                <img width="100%" :src="dialogImageUrl" alt="" />
                            </el-dialog>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title" @click="hideMsg()" v-if="submitData.ReturnCode">
            <div>关联订单</div>
        </div>
        <div class="search-ctn" v-if="submitData.ReturnCode">
            <el-form ref="formReturn" label-width="100px" style="width: 100%; padding-right: 15px; padding-left: 15px; margin-bottom: 10px">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="售后单号" prop="EntpCusId">
                                <el-input style="width: 100%" disabled v-model="submitData.ReturnCode"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="售后金额" prop="SId">
                                <el-input style="width: 100%" disabled v-model="submitData.ReturnMoney"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="已退金额" prop="SId">
                                <el-input style="width: 100%" disabled v-model="submitData.Refund"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title" @click="hideMsg()">
            <div>商品明细</div>
        </div>
        <div class="table-ctn edit-ctn" @click="hideMsg()" id="editCtn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="dataList"
                border=""
                show-summary
                :summary-method="getSummaries"
                style="width: 100%; margin-bottom: 10px; margin-top: 0px"
            >
                <el-table-column show-overflow-tooltip prop="APCode" label="汽配编码">
                    <template slot-scope="scope">
                        <img src="../../../assets/images/info.png" alt="" title="配件信息" class="info-icon" @click="showAPMsgDialog(scope.row.EntpTempGoodsId)" />
                        {{ scope.row.APCode }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodName" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="AutoSerise" label="车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="CostPrice" label="成本价"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="Price" label="销售价"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" label="销售总价">
                    <template slot-scope="scope">{{ (scope.row.Price * scope.row.Count).toFixed(2) }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="WarehousedCount" label="已出数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ReturnCount" label="已退数"></el-table-column>
            </el-table>
        </div>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--确认收款，完成收款提示框-->
        <el-dialog title="提示" :visible.sync="receiptDialogData.DialogVisible" width="30%" :close-on-click-modal="false">
            <div style="padding: 20px; font-size: 16px">{{ receiptDialogData.text }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="receiptDialogData.DialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="receiptDialogConfirm(receiptDialogData.record, '1')" size="small" v-if="receiptDialogData.confirmBtn">确认</el-button>
                <el-button type="primary" @click="receiptDialogConfirm(receiptDialogData.record, '1')" size="small" v-if="receiptDialogData.onlyConfirmBtn">仅确认收款</el-button>
                <el-button type="primary" @click="receiptDialogConfirm(receiptDialogData.record, '2')" size="small" v-if="receiptDialogData.confirmAndFinishBtn"
                    >确认并完成收款</el-button
                >
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="确认收款" :visible.sync="ReceiptVisible" width="1000px">
            <div class="dialog-content" v-if="ReceiptVisible">
                <confirmEditReceipt @closeReceipt="closeReceipt" :receiptData="receiptData" :type="0"></confirmEditReceipt>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="完成收款" :visible.sync="finishVisible" width="1000px">
            <div class="dialog-content" v-if="finishVisible">
                <finishReceiptOrPayment @closeFinish="closeFinish" :finishData="finishData" :type="0"></finishReceiptOrPayment>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import confirmEditReceipt from '@/components/business/revenue/confirmReceiptOrPayment';
import finishReceiptOrPayment from '@/components/business/revenue/finishReceiptOrPayment';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: 'confirmReceipt',
    components: {
        APMsg,
        APHistory,
        breadcrumb,
        confirmEditReceipt,
        finishReceiptOrPayment
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            orderImages: [],
            uploadImgData: null,
            uploadImgUrl: this.$util.BASE_URL + '/EntpSaleOrder/AddOrderImage',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            dialogImageUrl: '',
            dialogImageVisible: false,
            EntpTempGoodsIdEdit: '',
            showOrderMsg: true,
            APMsgVisible: false,
            historyVisible: false,
            ReceiptVisible: false,
            finishVisible: false,
            allNum: 1,
            allMoney: 0,
            submitData: {
                SId: userMsg.EmployeeId,
                FollowerId: '',
                ShipAmount: '',
                EntpCusId: '',
                PayType: null,
                ShipType: null,
                FullAddress: null,
                PhoneNum: '',
                Remark: '',
                DetailList: []
            },
            download_url: this.$util.QN_URL_BASE,
            dataList: [],
            action: '', //操作类型 see 查看 creceipt 确认收款
            id: '',
            pageTitle: '确认收款',
            permission: {},
            funcConfig: false,
            receiptRecords: [],
            receiptRecordsCount: 0,
            receiptRecordsUnConfirmCount: 0, //收款记录未确认数
            confirmPayRecordData: {
                Id: '',
                OperateType: 1
            },
            receiptDialogData: {
                text: '是否确认收款？',
                confirmBtn: false,
                onlyConfirmBtn: false,
                confirmAndFinishBtn: false,
                DialogVisible: false,
                record: {}
            },
            receiptData: {},
            finishData: { allMoney: 0, orderId: '', payType: '' },
            mustInThenFinish: false //是否需要完成入仓才能完成收款操作
        };
    },
    created() {
        this.getEntpFuncConfigData();
    },
    mounted() {
        this.permission = this.$util.getPermission('salesOrderGathering');
        this.id = this.$route.query.id;
        this.action = this.$route.query.action;
        if (this.action == 'see') this.pageTitle = '订单详情';
        this.getOrderDetail();
    },
    methods: {
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
        },
        showMsg() {
            this.showOrderMsg = true;
        },

        //收款记录列表
        getReceiptRecords() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetPaymentAndReceiptRecordsByOId',
                    data: {
                        orderId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.receiptRecordsCount = res.count;
                    this.receiptRecords = data;

                    let UnConfirmCount = 0;
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].IsConfirm == false && data[i].IsCancel == false) {
                            UnConfirmCount++;
                        }
                    }
                    this.receiptRecordsUnConfirmCount = UnConfirmCount;
                })
                .catch(err => {});
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderById',
                    data: {
                        EntpCusOId: this.id,
                        IsGetRecordImages: true
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    this.submitData = data;
                    this.orderImages = data.OrderImages;
                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }

                    // this.allMoney = _allMoney;
                    // this.allNum = _allNum;
                    this.dataList = DetailList;
                    this.getReceiptRecords();
                });
        },
        //确认收款
        confirmPayRecord(item) {
            if (item && item.Id) {
                this.$confirm('是否确认收款？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.confirmPayRecordData.Id = item.Id;
                        this.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/OperatePaymentAndReceiptRecord',
                                data: this.confirmPayRecordData
                            })
                            .then(res => {
                                this.getOrderDetail();
                                this.$util.successMsg('确认收款成功');
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效的收款记录');
            }
        },
        //完成收款
        finishReceipt() {
            let tip = '是否完成收款？';
            let receiptRecords = this.receiptRecords;
            if (!receiptRecords || receiptRecords.length == 0) {
                tip = '未存在收款记录，是否确认完成收款';
            } else {
                let ConfirmCount = 0;
                for (let i = 0; i < receiptRecords.length; i++) {
                    if (receiptRecords[i].IsConfirm == false && receiptRecords[i].IsCancel == false) {
                        this.$util.warningMsg('存在未确认的收款申请，请先确认');
                        return false;
                    }
                    if (receiptRecords[i].IsConfirm) ConfirmCount++;
                }
                if (ConfirmCount == 0) {
                    this.$util.warningMsg('未存在有效的收款记录，不能完成收款');
                    return false;
                }

                if (this.submitData.Paid < this.submitData.SurplusMoney) {
                    tip = '已收款金额小于订单总金额，是否完成收款？';
                }
            }
            this.$confirm(tip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            })
                .then(() => {
                    this.$util
                        .axiosPost({
                            url: '/api/EntpSaleOrder/FinishPaymentOrReceipt',
                            data: {
                                orderId: this.id,
                                oType: '0',
                                userId: this.userMsg.EmployeeId
                            }
                        })
                        .then(res => {
                            this.getOrderDetail();
                            this.$store.commit('updateNeedRefresh', true);
                            this.$util.successMsg('完成收款成功');
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        //显示提示框
        showReceiptDialog(item) {
            if (this.submitData.Paid + item.NowPay >= this.submitData.SurplusMoney) {
                this.receiptDialogData.text = '已收款总金额已经等于或大于订单金额！';
                this.receiptDialogData.onlyConfirmBtn = true;
                this.receiptDialogData.confirmAndFinishBtn = true;
                this.receiptDialogData.confirmBtn = false;
            } else {
                this.receiptDialogData.text = '是否确认收款？';
                this.receiptDialogData.onlyConfirmBtn = false;
                this.receiptDialogData.confirmAndFinishBtn = false;
                this.receiptDialogData.confirmBtn = true;
            }
            this.receiptDialogData.record = item;
            this.receiptDialogData.DialogVisible = true;
        },
        //1仅确认收款，2确认并完成收款
        receiptDialogConfirm(item, type) {
            this.receiptDialogData.DialogVisible = false;
            let data = {
                orderId: this.id,
                oType: '0',
                userId: this.userMsg.EmployeeId,
                recordId: item.Id,
                confirmType: type
            };
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/ConfirmAndFinishPaymentOrReceipt',
                    data: data
                })
                .then(res => {
                    this.getOrderDetail();
                    this.$util.successMsg('确认收款成功');
                })
                .catch(() => {});
        },
        //获取企业的功能设置结果
        getEntpFuncConfigData() {
            this.$util.getSysConfig('xsgdy').then(res => {
                this.funcConfig = res.Result;
            });
        },
        getFinishReceiptConfigData() {
            this.$util.getSysConfig('ddsfkxz').then(res => {
                this.mustInThenFinish = res.Result;
            });
        },
        //确认收款
        showConfirmDialog(item) {
            if (item && item.Id) {
                this.receiptData = item;
                this.ReceiptVisible = true;
            } else {
                this.$util.warningMsg('请选择有效的收款记录');
            }
        },
        closeReceipt(edit) {
            this.ReceiptVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        //有弹窗
        finishAndEditReceipt() {
            let that = this;
            let tip = '是否完成收款？';
            let receiptRecords = this.receiptRecords;
            if (!receiptRecords || receiptRecords.length == 0) {
                tip = '未存在收款记录，是否确认完成收款';
                this.$confirm(tip, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.finishData.payType = that.submitData.PayType;
                        that.finishData.allMoney = that.submitData.SurplusMoney.toFixed(2); // that.allMoney.toFixed(2);
                        that.finishData.orderId = that.id;
                        that.finishVisible = true;
                    })
                    .catch(() => {});
            } else {
                let ConfirmCount = 0;
                for (let i = 0; i < receiptRecords.length; i++) {
                    if (receiptRecords[i].IsConfirm == false && receiptRecords[i].IsCancel == false) {
                        this.$util.warningMsg('存在未确认的收款申请，请先确认');
                        return false;
                    }
                    if (receiptRecords[i].IsConfirm) ConfirmCount++;
                }
                if (ConfirmCount == 0) {
                    that.finishData.allMoney = that.allMoney.toFixed(2);
                    that.finishData.orderId = that.id;
                    that.finishVisible = true;
                    return false;
                }
                if (this.submitData.Paid < this.submitData.SurplusMoney) {
                    tip = '已收款金额小于订单总金额，是否完成收款？';
                }

                this.$confirm(tip, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/FinishPaymentOrReceipt',
                                data: {
                                    orderId: that.id,
                                    oType: '0',
                                    userId: this.userMsg.EmployeeId
                                }
                            })
                            .then(res => {
                                this.getOrderDetail();
                                this.$store.commit('updateNeedRefresh', true);
                                this.$util.successMsg('完成收款成功');
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            }
        },
        closeFinish(edit) {
            this.finishVisible = false;
            if (edit) {
                this.$store.commit('updateNeedRefresh', true);
                this.getOrderDetail();
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    sums[2] = '合计';
                    return;
                } else if (index === 0 || index === 1 || index === 4) {
                    sums[index] = '';
                    return;
                } else if (index === 5 ) {
                    sums[index] = data.reduce((prev, curr) => {
                        return prev + Number(curr.Count) * Number(curr.Price);
                    }, 0);
                    sums[index] = sums[index].toFixed(3) * 1;
                    return;
                }  else if (index === 6) {
                    sums[index] = data.reduce((prev, curr) => {
                        return prev + Number(curr.Count) * Number(curr.Price);
                    }, 0);
                    sums[index] = sums[index].toFixed(2);
                    return;
                }else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = sums[index].toFixed(2) * 1;
                    } else {
                        sums[index] = 'N/A';
                    }
                }
            });

            return sums;
        },
        getSummaries_apply(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    let totalAmount = 0;
                    if (data.length > 0) totalAmount = Number(data[0].SumPayable);
                    let applyTotal = data.reduce((prev, curr) => {
                        if (curr.IsCancel) return prev;
                        else return prev + Number(curr.ApplyPay);
                    }, 0);
                    sums[index] = '剩余可申请：' + (totalAmount > applyTotal ? totalAmount - applyTotal : 0).toFixed(2);
                    return;
                } else if (index === 3) {
                    let sum = data.reduce((prev, curr) => {
                        if (curr.IsCancel || !curr.IsConfirm) return prev;
                        else return prev + Number(curr.NowPay);
                    }, 0);
                    sums[index] = '已收：' + sum.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        }
    }
};
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px;
}
.form-uploadImg div {
    width: 100%;
    font-size: 14px;
    margin-bottom: 10px;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;
}
</style>
<style lang="less">
.revenue-order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
.el-row {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple {
    background: #d3dce6;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
</style>
